ACC.configit = {
  configItFlag: $('.ph-configItEnabled').html(),
  containerClass: '.ph-configit_container',
  addToCartForm: '#addToCartForm',
  pdpconfigitbuttonClass: '.ph-pdpconfigitbutton',
  currentConfigitProduct: '.currentConfigitProduct',
  defaultloader: '.ph-loader__default',
  cartPageClass: '.ph-page-cartPage',
  dataSalesOrg: 'data-salesOrg',
  dataProductcode: 'data-productcode',
  eventFlag: false,
  cartCurrentConfigurationId: '.cartCurrentConfigurationId',
  configitProductUrl: function(productCode, salesOrg) {
    var cid = $(ACC.configit.cartCurrentConfigurationId).val();

    if (cid && $(ACC.configit.cartPageClass).length > 0) {
      ACC.configit.embedConfigit(productCode, '/configit/getConfigIDURL/' + cid);
    } else if ($(ACC.configit.cartPageClass).length === 0) {
      ACC.configit.embedConfigit(productCode, '/configit/create/' + productCode + '?salesOrg=' + salesOrg);
    }
  },
  isValidOrigin: function(originUrl) {
    var configItOriginUrl = $('.configItUrl').text(),
        validOrigin = false;

    if (originUrl && configItOriginUrl) {
      var originUrlValue = originUrl.replace(/\/$/, ''),
          configItOriginUrlValue = configItOriginUrl.replace(/\/$/, '');

      if (originUrlValue === configItOriginUrlValue) {
        validOrigin = true;
      }

      if (originUrlValue === window.location.origin) {
        validOrigin = true;
      }
    }

    return validOrigin;
  },
  configItCartPage: function(cid) {
    $(ACC.configit.cartCurrentConfigurationId).val(cid);
    $('.ph-configitSaveInCart').attr('action', '/configit/read/' + cid);
    $('.ph-configitSaveInCart').submit();
  },
  configItButtonAction: function(task, cid) {
    var currProdId = $(ACC.configit.currentConfigitProduct).text();

    if (task === 'configuration_saved' && currProdId !== '') {
      if ($('.ph-page-productDetails').length > 0) {
        currProdId = '';
      }

      if ($(ACC.configit.cartPageClass).length > 0) {
        ACC.configit.configItCartPage(cid);
      } else if (cid !== '' && $(ACC.configit.addToCartForm + currProdId).length > 0) {
        var newInput = '<input type="hidden" class="isConfigitEnabled" name="isConfigitEnabled" value="true">';

        newInput = newInput + '<input type="hidden" class="configurationId" name="configurationId" value="' + cid + '">';
        $(ACC.configit.addToCartForm + currProdId).find('.isConfigitEnabled,.configurationId').remove();
        $(ACC.configit.addToCartForm + currProdId).append(newInput);
        ACC.configit.configitAddToCart();
      } else {
        $(ACC.configit.defaultloader).hide();
      }

      $(ACC.configit.defaultloader).show();
      ACC.configit.hideConfigScreen();
    } else if (task === 'configuration_close') {
      ACC.configit.hideConfigScreen();
    } else if (task === 'configuration_error') {
      ACC.configit.hideConfigScreen();
      $('.ph-customglobalmsg > .ph-information_message').addClass('ph-info_negative').removeClass('hiddenClass').show();
      $('.ph-customglobal_message').html(cid);
    }
  },
  observeConfigItEvent: function() {
    function eventAction(event) {
      if (ACC.configit.isValidOrigin(event.origin) && event.data && typeof event.data === 'object') {
        ACC.configit.configItButtonAction(event.data.message, event.data.cid);
      }
    }

    if (window.addEventListener) {
      window.addEventListener('message', eventAction, false);
    } else {
      window.attachEvent('onmessage', eventAction);
    }
  },
  embedConfigit: function(productCode, configitProductUrl) {
    var addToCartFormid = ACC.configit.addToCartForm + productCode,
        addtocartLoaderClass = '.ph-addtocart-loader';

    if (ACC.configit.configItFlag === 'true') {
      if ($(ACC.configit.cartPageClass).length > 0) {
        $(ACC.configit.defaultloader).show();
      }

      $(ACC.configit.currentConfigitProduct).text(productCode);
      $(addToCartFormid).find('.ph-plpconfigitbutton').find(addtocartLoaderClass).show();
      $('.ph-pdp_buttons_section').find(ACC.configit.pdpconfigitbuttonClass).addClass('ph-disabledbutton');
      $(ACC.configit.pdpconfigitbuttonClass).prepend('<div class="ph-addtocart-loader"></div>');
      $(ACC.configit.containerClass).html('').removeClass('hidden');

      var emb = document.createElement('embed');
      var configitContainer = document.querySelector(ACC.configit.containerClass);

      emb.src = configitProductUrl;
      emb.type = 'text/html';
      emb.style = 'width:100%; height: 80vh;';
      configitContainer.appendChild(emb);
      emb.addEventListener('load', function() {
        ACC.configit.showConfigScreen();
        $(addToCartFormid).find('.ph-plpconfigitbutton').find(addtocartLoaderClass).hide();
        $(ACC.configit.pdpconfigitbuttonClass).find(addtocartLoaderClass).remove();
        $('.ph-pdp_buttons_section').find(ACC.configit.pdpconfigitbuttonClass).removeClass('ph-disabledbutton');
      });
    }
  },
  showConfigScreen: function() {
    $(ACC.configit.containerClass).removeClass('hidden').addClass('ph-configit_loaded');
    $('.ph-page_container > .ph-middleContent').addClass('hidden');

    if ($(ACC.configit.cartPageClass).length > 0) {
      $(ACC.configit.defaultloader).hide();
    }

    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  },
  configitAddToCart: function() {
    var productCode = $(ACC.configit.currentConfigitProduct).text();

    if ($(ACC.configit.addToCartForm).length > 0) {
      $(ACC.configit.addToCartForm).submit();
    } else if ($(ACC.configit.addToCartForm + productCode).length > 0) {
      $(ACC.configit.addToCartForm + productCode).submit();
    }

    $(ACC.configit.currentConfigitProduct).text('');
  },
  hideConfigScreen: function() {
    document.querySelector(ACC.configit.containerClass).innerHTML = '';
    $('.ph-page_container > .ph-middleContent').removeClass('hidden').removeClass('ph-configit_loaded');
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
    $(ACC.configit.currentConfigitProduct).text('');
  },
  plpConfigitButton: function(productCode, salesOrg) {
    var $plpConfigurationButton = $(document).find(ACC.configit.addToCartForm + productCode + ' .ph-decisionpage__addtocarholder').find('button');

    if (ACC.configit.configItFlag === 'true') {
      var buttonText = $plpConfigurationButton.html(),
          $productOutofstock = $('#productOutofstock_' + productCode),
          configitButtonHtml = '<button type="button" data-salesOrg="' + salesOrg + '" data-productcode="' + productCode + '" class="ph-plpconfigitbutton ';

      configitButtonHtml = configitButtonHtml + ' ph-icon-refreshcart ph-m-0 ph-p-0 ph-orangebutton ph-float-left">' + buttonText + '</button>';
      $plpConfigurationButton.hide();
      $plpConfigurationButton.after(configitButtonHtml);
      $productOutofstock.html($('.ph-config_product_msg').text()).show();
      $productOutofstock.parent().find('.ph-decision-page__price').addClass('ph-d-none');
    }

    if (ACC.configit.eventFlag === false) {
      ACC.configit.observeConfigItEvent();
    }
  },
  createPopUpContent: function(productCode) {
    var $itemRow = $('#cartitem_' + productCode),
        itemImageUrl = $itemRow.find('.product_image').find('.ph-freqorderedproduct__image').attr('src'),
        $productName = $('.ph-productname'),
        itemProductUrl = $itemRow.find($productName).attr('href'),
        itemProductName = $itemRow.find($productName).text(),
        itemProductCtn = $itemRow.find('.ph-productctn').html();
    var warrantyHtml = '';

    warrantyHtml = warrantyHtml + '<div class="ph-col-12 ph-col-md-3  ph-float-left ph-aedleft_image  ph-pr-0">';
    warrantyHtml = warrantyHtml + '<a href="' + itemProductUrl + '"><div class="ph-p-0 ph-text-center"><img class="ph-freqorderedproduct__image ph-hhsyoumaylikeimage" src="';
    warrantyHtml = warrantyHtml + itemImageUrl + '" alt="' + itemProductName + '" title="' + itemProductName + '"></div></a>';
    warrantyHtml = warrantyHtml + '</div><div class=" ph-col-12  ph-col-md-9 ph-float-left ph-aedright_content ph-pl-2"><div class="ph-prodname"><a href="';
    warrantyHtml = warrantyHtml + itemProductUrl + '">' + itemProductName + '</a></div><div class="ph-productctn">';
    warrantyHtml = warrantyHtml + itemProductCtn + '</div><div class="configItWarrantydata ph-col-12 ph-p-0 ph-float-left ph-mt-3 ph-mb-2"></div></div>';
    $('#configItWarrantyContent').html(warrantyHtml);
  },
  warrantyDropdown: function(data) {
    var optionData = data,
        labelItemText = $('.ph-warrentylink').text(),
        labelItem = '<label class=\'ph-aed_select_title\'>' + labelItemText + '</label>',
        warranty = '',
        priceVal = '';

    warranty = warranty + '<div class=\'ph-group_selectbox_items ph-icon-arrow-down\'>';
    warranty = warranty + '<select name="code" id="warrantyConfigSelect" class="ph-mandatory_configselect ph-common-configselect" isMandatory="true">';

    for (var options in optionData) {
      if (optionData !== '') {
        if (data[options].price && data[options].price.formattedValue) {
          priceVal = '&nbsp; (' + data[options].price.formattedValue + ')';
        }

        warranty = warranty + '<option data-productcodeselected="' + data[options].code + '"  value= "' + data[options].code + '" >' + data[options].name + priceVal + '</option>';
      }
    }

    warranty = warranty + '</select>';
    warranty = warranty + labelItem + '<span class="ph-exclamation-mark"></span></div>';

    $('.configItWarrantydata').append(warranty);

    if (optionData.length > 0) {
      ACC.configit.configurePopup();
    }
  },
  configurePopup: function() {
    var popupHeight = 'auto',
        maxHeight = '90%';

    $.colorbox({
      inline: true,
      href: '#configItWarrantyPopup',
      height: popupHeight,
      width: '100%',
      maxWidth: 640,
      maxHeight: maxHeight,
      overlayClose: false,
      scrolling: true,
      escKey: false,
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        $('.ph-configureproduct__buttons').css({
          position: 'sticky',
          bottom: '0'
        });
        $('#cboxContent #warrantyConfigSelect').selectBox();
        $(document).on('click', '#cboxContent .ph-popupconfigit_cancelbtn', function() {
          $.colorbox.close();
        });
      }
    });
  },
  getWarrantyProducts: function($this) {
    var ajaxPath = '/cart/configItProduct/getWarrantyProducts.json',
        disabledlink = 'ph-disabledlink',
        dataObj = {
          warrantykey: $this.attr('data-warrantykey'),
          salesOrg: $this.attr(ACC.configit.dataSalesOrg)
        };

    ACC.configit.createPopUpContent($this.attr('data-productcode'));
    $('#currentEntryNumber').val($this.attr('data-entry-number'));
    $this.addClass(disabledlink);
    $.ajax({
      url: ajaxPath,
      data: dataObj,
      success: function(result) {
        ACC.configit.warrantyDropdown(result);
        $(ACC.configit.defaultloader).hide();
        $this.removeClass(disabledlink);
      },
      fail: function() {
        $(ACC.configit.defaultloader).hide();
        $this.removeClass(disabledlink);
      },
      error: function() {
        $(ACC.configit.defaultloader).hide();
        $this.removeClass(disabledlink);
      }
    });
  }
};
$(document).ready(function() {
  $(document).on('click', '.ph-pdpconfigitbutton,.ph-plpconfigitbutton', function() {
    ACC.configit.configitProductUrl($(this).attr(ACC.configit.dataProductcode), $(this).attr(ACC.configit.dataSalesOrg));
  });
  $(document).on('click', '.ph-cartconfigitbutton', function() {
    var salesOrg = $(this).attr(ACC.configit.dataSalesOrg),
        productcode = $(this).attr(ACC.configit.dataProductcode);

    $('.cartCurrentSalesOrg').val(salesOrg);
    $('.cartCurrentEntrynumber').val($(this).attr('data-entry-number'));
    $('.cartCurrentProductCode').val(productcode);
    $(ACC.configit.cartCurrentConfigurationId).val($(this).attr('data-cid'));
    ACC.configit.configitProductUrl(productcode, salesOrg);
  });
  $(document).on('click', '.ph-configitwarrantybutton', function() {
    $(ACC.configit.defaultloader).show();
    ACC.configit.getWarrantyProducts($(this));
  });

  if ($(document).find('.ph-pdp-isConfigitEnabled').text() === 'true') {
    $(document).find('.ph-pdp_product_quantity').removeClass('hidden');
  }

  $(document).on('click', '.secondaryHeader .rowFlex > span', function() {
    $(this).addClass('event_clicked');
  });

  if (ACC.configit.configItFlag === 'true' && $('.ph-cartconfigitbutton,.ph-pdpconfigitbutton,.ph-plpconfigitbutton').length > 0) {
    ACC.configit.observeConfigItEvent();
    ACC.configit.eventFlag = true;
  }

  $(document).on('click', '#cboxContent .ph-popupconfigit_applybtn', function() {
    var items = {
      entryNumber: $('#currentEntryNumber').val(),
      code: $('#warrantyConfigSelect option:selected').attr('data-productcodeselected')
    };

    $('#cboxLoadingGraphic').show();
    $('#cboxLoadingOverlay').show();
    $.ajax({
      url: '/cart/configItProduct/setWarrantyProducts.json',
      type: 'POST',
      data: items,
      success: function() {
        window.location.reload();
      }
    });
  });
});
